/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Api
 * ISM | New World W3 Metaverse Platform API
 * OpenAPI spec version: 0.1.0
 */
export interface HealthStatus {
  status: string;
}

export type SpaceTimeOfDay = typeof SpaceTimeOfDay[keyof typeof SpaceTimeOfDay];


export const SpaceTimeOfDay = {
  day: 'day',
  night: 'night',
} as const;

export interface Space {
  id: number;
  name: string;
  /** Region code: us-cities, europe, asia, moon, mars */
  region: string;
  /** Human-readable region name */
  regionLabel?: string;
  /** city, residential, commercial, nature, space */
  category: string;
  timeOfDay: SpaceTimeOfDay;
  description: string;
  imageUrl: string;
  onlineCount: number;
  maxCapacity: number;
  featured?: boolean;
  /** @nullable */
  cityName?: string | null;
  /**
     * lat,lng for Earth regions
     * @nullable
     */
  coordinates?: string | null;
  /**
     * External URL to open instead of the internal space detail page (e.g. VIVERSE, VRChat)
     * @nullable
     */
  externalUrl?: string | null;
}

export type AvatarRarity = typeof AvatarRarity[keyof typeof AvatarRarity];


export const AvatarRarity = {
  common: 'common',
  rare: 'rare',
  epic: 'epic',
  legendary: 'legendary',
} as const;

export interface Avatar {
  id: number;
  name: string;
  /** human, cyborg, fantasy, alien */
  style: string;
  previewUrl: string;
  price: number;
  /** ISM, ETH, MATIC, SOL */
  currency?: string;
  /** ethereum, polygon, solana */
  blockchain: string;
  /** @nullable */
  tokenId: string | null;
  rarity?: AvatarRarity;
  owned?: boolean;
}

export interface Product {
  id: number;
  /** @nullable */
  creatorId?: number | null;
  name: string;
  /** avatar, vehicle, property, wearable, furniture, art, merch, service, experience, digital */
  category: string;
  price: number;
  /** @nullable */
  priceUsd?: number | null;
  /** ISM, ETH, MATIC, SOL, USD, GLO, HALO */
  currency: string;
  /** blockchain, card, both */
  paymentOptions?: string;
  blockchain: string;
  sellerName: string;
  /** @nullable */
  sellerAvatar?: string | null;
  imageUrl: string;
  description: string;
  /** digital, physical, service, experience */
  productType?: string;
  /** @nullable */
  tokenId?: string | null;
  /** @nullable */
  contractAddress?: string | null;
  verified?: boolean;
  likes?: number;
  views?: number;
  featured?: boolean;
  createdAt?: string;
}

export interface ProductInput {
  creatorId?: number;
  name: string;
  category: string;
  price: number;
  priceUsd?: number;
  currency: string;
  paymentOptions?: string;
  productType?: string;
  blockchain: string;
  imageUrl: string;
  description: string;
  tokenId?: string;
  contractAddress?: string;
}

export interface ProductPatch {
  name?: string;
  price?: number;
  description?: string;
  featured?: boolean;
}

export interface Event {
  id: number;
  title: string;
  description: string;
  spaceId: number;
  spaceName: string;
  startTime: string;
  endTime: string;
  hostName: string;
  /** @nullable */
  hostAvatar?: string | null;
  imageUrl: string;
  attendeeCount: number;
  /** @nullable */
  maxAttendees?: number | null;
  /** concert, meetup, exhibition, gaming, fashion, sports */
  category?: string;
  /** @nullable */
  ticketPrice?: number | null;
  /** @nullable */
  currency?: string | null;
  /** @nullable */
  blockchain?: string | null;
  live?: boolean;
}

export interface EventInput {
  title: string;
  description: string;
  spaceId: number;
  startTime: string;
  endTime: string;
  hostName: string;
  category?: string;
  ticketPrice?: number;
  currency?: string;
  blockchain?: string;
  maxAttendees?: number;
  imageUrl?: string;
}

export interface PlatformStats {
  totalUsers: number;
  activeUsers: number;
  totalSpaces: number;
  totalProducts: number;
  totalEvents: number;
  totalTransactions: number;
  ismTokenPrice: number;
  ismTokenChange24h?: number;
  totalVolumeUsd?: number;
}

export type RegionPlanet = typeof RegionPlanet[keyof typeof RegionPlanet];


export const RegionPlanet = {
  earth: 'earth',
  moon: 'moon',
  mars: 'mars',
} as const;

export interface Region {
  id: string;
  name: string;
  label: string;
  planet: RegionPlanet;
  spaceCount: number;
  onlineUsers?: number;
  imageUrl: string;
  description?: string;
}

export interface Creator {
  id: number;
  displayName: string;
  username: string;
  /** @nullable */
  bio?: string | null;
  /** fashion, art, music, fitness, lifestyle, gaming */
  category: string;
  avatarUrl: string;
  /** @nullable */
  bannerUrl?: string | null;
  subscriberCount: number;
  contentCount: number;
  /** Total GLO earned from content rewards */
  gloEarned: number;
  /** Total HALO earned */
  haloEarned: number;
  /**
     * Polygon Amoy wallet address
     * @nullable
     */
  walletAddress?: string | null;
  verified?: boolean;
  featured?: boolean;
  /** Monthly subscription price in HALO */
  subscriptionPriceHalo?: number;
}

export type MembersContentOrientationTagsItem = typeof MembersContentOrientationTagsItem[keyof typeof MembersContentOrientationTagsItem];


export const MembersContentOrientationTagsItem = {
  day: 'day',
  night: 'night',
  ism: 'ism',
} as const;

/**
 * Access tier required to view
 */
export type MembersContentTier = typeof MembersContentTier[keyof typeof MembersContentTier];


export const MembersContentTier = {
  free: 'free',
  standard: 'standard',
  premium: 'premium',
} as const;

export type MembersContentMediaType = typeof MembersContentMediaType[keyof typeof MembersContentMediaType];


export const MembersContentMediaType = {
  video: 'video',
  image: 'image',
  audio: 'audio',
  livestream: 'livestream',
  photo: 'photo',
  series: 'series',
  virtual: 'virtual',
} as const;

export interface MembersContent {
  id: number;
  creatorId: number;
  creatorName: string;
  /** @nullable */
  creatorAvatar?: string | null;
  title: string;
  /** @nullable */
  description?: string | null;
  /** fashion, art, music, fitness, lifestyle, gaming */
  category: string;
  /** Editorial sections where this content appears */
  orientationTags: MembersContentOrientationTagsItem[];
  /** Access tier required to view */
  tier: MembersContentTier;
  mediaType: MembersContentMediaType;
  thumbnailUrl: string;
  /** @nullable */
  mediaUrl?: string | null;
  /**
     * Duration for video/audio content
     * @nullable
     */
  durationSeconds?: number | null;
  likeCount: number;
  viewCount: number;
  /** GLO gas fee paid when this content was uploaded (base 0.01818) */
  gasFeeGlo: number;
  /** HALO equivalent of gas fee (base 0.0545) */
  gasFeeHalo: number;
  /** USD value of gas fee (base $0.20) */
  gasFeeUsd: number;
  /**
     * Polygon transaction hash for gas fee
     * @nullable
     */
  txHash?: string | null;
  featured: boolean;
  /** 18+ adult content flag — hidden by default on ISM New World */
  isAdult: boolean;
  /**
     * Original Only-Memberz content ID (for dedup on sync)
     * @nullable
     */
  omContentId?: string | null;
  createdAt: string;
}

export type MembersContentInputOrientationTagsItem = typeof MembersContentInputOrientationTagsItem[keyof typeof MembersContentInputOrientationTagsItem];


export const MembersContentInputOrientationTagsItem = {
  day: 'day',
  night: 'night',
  ism: 'ism',
} as const;

export type MembersContentInputTier = typeof MembersContentInputTier[keyof typeof MembersContentInputTier];


export const MembersContentInputTier = {
  free: 'free',
  standard: 'standard',
  premium: 'premium',
} as const;

export type MembersContentInputMediaType = typeof MembersContentInputMediaType[keyof typeof MembersContentInputMediaType];


export const MembersContentInputMediaType = {
  video: 'video',
  image: 'image',
  audio: 'audio',
  livestream: 'livestream',
  photo: 'photo',
  series: 'series',
  virtual: 'virtual',
} as const;

export interface MembersContentInput {
  creatorId: number;
  title: string;
  description?: string;
  category: string;
  orientationTags?: MembersContentInputOrientationTagsItem[];
  tier: MembersContentInputTier;
  mediaType: MembersContentInputMediaType;
  thumbnailUrl: string;
  mediaUrl?: string;
  durationSeconds?: number;
  /** Mark content as 18+ adult (hidden by default on ISM New World) */
  isAdult?: boolean;
  /** Requester's wallet — GLO gas fee deducted here */
  walletAddress?: string;
}

export interface OmSyncResult {
  syncedAt: string;
  contentFetched: number;
  contentUpserted: number;
  modelsFetched: number;
  errors: string[];
  /** HTTP status from last OM API call */
  lastOmApiStatus?: number;
}

export interface LikeResult {
  contentId: number;
  likeCount: number;
  /** GLO awarded to creator (0.002) */
  gloRewarded: number;
  /** HALO equivalent rewarded */
  haloRewarded: number;
}

export interface GasFeeRecord {
  id: number;
  contentId: number;
  /** @nullable */
  contentTitle?: string | null;
  walletAddress: string;
  gloAmount: number;
  haloAmount: number;
  usdAmount: number;
  /** @nullable */
  txHash?: string | null;
  createdAt: string;
}

export interface MembersRates {
  /** 1 GLO in USD (11.00) */
  gloUsd: number;
  /** 1 HALO in USD (3.6667) */
  haloUsd: number;
  /** HALO per 1 GLO (3) */
  haloPegGlo: number;
  /** Base upload gas fee in USD (0.20) */
  uploadGasFeeUsd: number;
  /** Base upload gas fee in GLO (0.01818) */
  uploadGasFeeGlo: number;
  /** Base upload gas fee in HALO (0.0545) */
  uploadGasFeeHalo: number;
  /** GLO awarded per like/rating (0.002) */
  likeRewardGlo: number;
  /** HALO equivalent per like (0.006) */
  likeRewardHalo: number;
  /** USD value per like (0.022) */
  likeRewardUsd: number;
}

export type ListSpacesParams = {
/**
 * Filter by region (us-cities, europe, asia, moon, mars)
 */
region?: string;
/**
 * Filter by time of day setting
 */
timeOfDay?: ListSpacesTimeOfDay;
/**
 * Filter by category (city, residential, commercial, nature, space)
 */
category?: string;
};

export type ListSpacesTimeOfDay = typeof ListSpacesTimeOfDay[keyof typeof ListSpacesTimeOfDay];


export const ListSpacesTimeOfDay = {
  day: 'day',
  night: 'night',
} as const;

export type ListAvatarsParams = {
/**
 * Filter by style (human, cyborg, fantasy, alien)
 */
style?: string;
};

export type ListProductsParams = {
/**
 * Filter by category (avatar, vehicle, property, wearable, furniture, art)
 */
category?: string;
/**
 * Filter by blockchain (ethereum, polygon, solana)
 */
blockchain?: string;
minPrice?: number;
maxPrice?: number;
/**
 * Filter by creator ID (studio products for a specific creator)
 */
creatorId?: number;
};

export type ListEventsParams = {
/**
 * Filter events by space
 */
spaceId?: number;
/**
 * Only return upcoming events
 */
upcoming?: boolean;
};

export type ListCreatorsParams = {
/**
 * Filter by content category (fashion, art, music, fitness, lifestyle, gaming)
 */
category?: string;
featured?: boolean;
};

export type ListMembersContentParams = {
creatorId?: number;
category?: string;
tier?: ListMembersContentTier;
/**
 * Filter by editorial orientation label
 */
orientation?: ListMembersContentOrientation;
/**
 * Include 18+ adult content (default false — excluded)
 */
showAdult?: boolean;
};

export type ListMembersContentTier = typeof ListMembersContentTier[keyof typeof ListMembersContentTier];


export const ListMembersContentTier = {
  free: 'free',
  standard: 'standard',
  premium: 'premium',
} as const;

export type ListMembersContentOrientation = typeof ListMembersContentOrientation[keyof typeof ListMembersContentOrientation];


export const ListMembersContentOrientation = {
  day: 'day',
  night: 'night',
  ism: 'ism',
} as const;

export type GetFeaturedMembersContentParams = {
/**
 * Filter by editorial orientation label
 */
orientation?: GetFeaturedMembersContentOrientation;
};

export type GetFeaturedMembersContentOrientation = typeof GetFeaturedMembersContentOrientation[keyof typeof GetFeaturedMembersContentOrientation];


export const GetFeaturedMembersContentOrientation = {
  day: 'day',
  night: 'night',
  ism: 'ism',
} as const;

export type ListGasFeesParams = {
walletAddress?: string;
contentId?: number;
};

